/**
 * Отправка ajax запроса по заданным параметрам
 *
 * @param {object} options
 */
export default function sendRequest(options)
{
    "use strict";

    if (options.url === undefined) {
        options.url = location.href;
    }
    if (options.method === undefined) {
        options.method = "GET";
    }
    if (options.data === undefined) {
        options.data = "";
    } else {
        var data = "";
        for (var x in options.data) {
            if (data !== "") {
                data += "&";
            }
            data += encodeURIComponent(x) + "=" + encodeURIComponent(options.data[x]);
        }
        options.data = data;
    }

    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200 && options.success !== undefined) {
            options.success(xhr.response);
        }
    }
    if (options.method === "POST") {
        xhr.open(options.method, options.url, true);
        xhr.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded; charset=UTF-8"
        );
        xhr.send(options.data);
    } else {
        if (options.data.length) {
            options.url += "?";
        }
        xhr.open(options.method, options.url + options.data, true);
        xhr.send(null);
    }
}